import { useState } from "react";
import Imgix from "react-imgix";
import Assets from "../../assets/Assets";

export const ImgixWithFallback = ({ src, fallbackSrc, alt, ...props }) => {
  const [hasError, setHasError] = useState(false);


  
  if (hasError) {
    return (
      <img
        src={fallbackSrc ? fallbackSrc : Assets.EXPIRED_PLACEHOLDER}
        alt={alt}
        {...props}
        onError={() => console.warn("Fallback image also failed.")}
      />
    );
  }
  const handleError = () => {
    setHasError(true);
  };
  return (
    <>
      <img
        src={src}
        alt=''
        style={{ display: "none" }}
        onError={handleError}
      />
      <Imgix
        src={src}
        alt={alt}
        srcSetOptions={{}}
        onError={handleError}
        {...props}
      />
    </>
  );
};
